define('facets_items_collection_view_row.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('facets_items_collection_view_row', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"\"><div data-type=\"backbone.collection.view.cells\"></div></div>  ";
},"useData":true}, 'extensions/Eureka/MaxaPartPicker/1.1.0/', 'extensions/Eureka/MaxaPartPicker/1.1.0/', Handlebars);
});